var map = {
	"./CCAMX45.png": "b1b4",
	"./CCCal45.png": "8957",
	"./CCIsracard45.png": "7fa3",
	"./CCLeumi45.png": "f8d6",
	"./discount.svg": "2b32",
	"./doar.svg": "1562",
	"./egud.svg": "2ea7",
	"./habeinleumi.svg": "37c7",
	"./hapoalim.svg": "4171",
	"./leumi.svg": "d191",
	"./massad.svg": "ebc9",
	"./mercantile.png": "072a",
	"./mizrachi.svg": "c2ee",
	"./otsar.png": "ccf8",
	"./pagi.png": "3f54",
	"./ubank.png": "f8a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "193f";